export const optimizeCaller = callback => {
  let tick = false;
  return () => {
    if (tick) return;
    tick = true;
    return window.requestAnimationFrame(() => {
      tick = false;
      return callback();
    });
  };
};

export const imageLoadCheck = (container, callback) => {
  const imgs = container.querySelectorAll('img');
  if (imgs.length === 0) {
    callback();
    return;
  }
  let count = 0;
  const complateCheck = () => {
    count++;
    if (count >= imgs.length) {
      callback();
    }
  };

  imgs.forEach(_img => {
    const img = new Image(_img);
    img.src = _img.getAttribute('src');
    img.onload = () => {
      complateCheck();
    };
    img.onerror = () => {
      complateCheck();
    };
    img.onAbort = () => {
      complateCheck();
    };
  });
};
